<template>
  <div class="conference" >
    <div class="conference-btn-content" v-if="!play">
      <div @click="clickPlay" class="conference-btn-play">
        <svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" clip-rule="evenodd" viewBox="0 0 500 500" id="play">
          <path fill="url(#_Linear1)" d="M250,25C374.181,25 475,125.819 475,250C475,374.181 374.181,475 250,475C125.819,475 25,374.181 25,250C25,125.819 125.819,25 250,25ZM341.499,241.407C344.528,243.21 346.384,246.475 346.384,250C346.384,253.525 344.528,256.79 341.499,258.593C310.248,277.195 236.585,321.042 204.73,340.003C201.639,341.843 197.799,341.881 194.672,340.103C191.547,338.326 189.615,335.006 189.615,331.411L189.615,168.589C189.615,164.994 191.547,161.674 194.672,159.897C197.799,158.119 201.639,158.157 204.73,159.997C236.585,178.958 310.248,222.805 341.499,241.407Z"/>
          <defs>
            <linearGradient id="_Linear1" x1="0" x2="1" y1="0" y2="0" gradientTransform="matrix(500 -500 500 500 0 500)" gradientUnits="userSpaceOnUse">
              <stop offset="0" stop-color="#441660"/>
              <stop offset="1" stop-color="#8b26eb"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="conference-btn-text m-t-2 text-x4">
        Начать конференцию
      </div>
  </div>
  <div  v-if="item && user && play" class="conference-body">
          <vue-jitsi-meet
                ref="jitsiRef"
                domain="jitsi.avtest.uz"
                :options="jitsiOptions"
      ></vue-jitsi-meet>
  </div>
  
  </div>
</template>

<script>
import { cardUpdateResource, cardContentResource } from "@/plugins/functions";

import {mapState} from 'vuex';
export default {
  data: () => ({
    done:false,
    play: false,
    fields: [
      {
        key: "title",
        label: "Название",
        type: "field",
        textType: "text",
        readonly: false,
      },
      {
        key: "is_active",
        label: "Активен",
        type: "checkbox",
        textType: "text",
        readonly: false,
      },
      {
        key: "start_at",
        label: "Начало",
        type: "datetime",
        textType: "text",
        readonly: false,
      },
      {
        key: "unit",
        label: "Unit",
        type: "field",
        textType: "text",
        readonly: false,
      }
    ],
  }),

  props: ["item","close"],

  methods: {
    clickPlay(){
      this.play = true
    },
    onIFrameLoad(){
        this.$refs.jitsiRef.addEventListener('readyToClose', this.readyToClose);
    },
    readyToClose(){
            this.close();
            let query = Object.assign({}, this.$route.query);
            if (query['item_conference']) {
              delete query['item_conference'];
            } else {
              return false;
            }
            this.$router.replace({ query });
    }
  },

 destroyed(){
 
  },
  computed: {
    ...mapState(['user']),
    jitsiOptions () {

      return {
        roomName: this.item.unit,
        noSSL: false,
        userInfo: {
          email: this.user.email,
          displayName: this.user.full_name,
        },
        configOverwrite: {
          enableNoisyMicDetection: false,
          defaultLanguage:'ru'
        },
        interfaceConfigOverwrite: {
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          SHOW_CHROME_EXTENSION_BANNER: false,
          SHOW_PROMOTIONAL_CLOSE_PAGE: false,
          DEFAULT_LOCAL_DISPLAY_NAME: 'Вы',
            TOOLBAR_BUTTONS: [
                'microphone', 'camera',  'settings', 
                'hangup'
              ] 
        },
      onload: this.onIFrameLoad,

      };
    },
  },
};
</script>
<style lang="scss">
.conference {
  position:relative;
  &-body {
 
    width:100%;
    height: calc(100vh - 360px);
    background:#222;

    oveflow:hidden;
  }
}
.conference-btn-content{
  margin-top: 60px;
  margin-bottom: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.conference-btn-play{
  width: 80px;
  &:hover{
    cursor: pointer;
  }
}
.conference-btn-text{
  text-align: center;
}
</style>
